import styled from 'styled-components';

const DatePickerWrapper = styled.div`
  margin-bottom: 30px;
`;

DatePickerWrapper.displayName = 'DatePickerWrapper';

export default DatePickerWrapper;
